import algoliasearch from 'algoliasearch/lite';
import React from 'react';
import {
  InstantSearch,
  Hits,
  SearchBox,
  Pagination,
  ClearRefinements,
  RefinementList,
  Configure,
} from 'react-instantsearch-dom';
import PropTypes from 'prop-types';
import '../css/search.css';
import Layout from "../components/layout"
import SEO from "../components/seo"

const searchClient = algoliasearch(
  '93EOZZLE55',
  '4f2945de3bf5793decc8fe522f446228'
);

class Search extends React.Component {
    render() {
      return (
        <Layout>
          <SEO title="Search" keywords={[`Search`]} />
          <div className="ais-InstantSearch container">
            <div className="text-center"><h1 className="with-underline">Quick Search</h1></div>
            <InstantSearch indexName="pattyshomemadegifts" searchClient={searchClient}>
              <div className="left-panel">
                <ClearRefinements />
                <div className="filters categories">
                  <h2>Categories</h2>
                  <RefinementList attribute="category" />
                </div>
                <div className="filters prices">
                  <h2>Prices</h2>
                  <RefinementList attribute="price" />
                </div>
                <Configure hitsPerPage={10} />
              </div>
              <div className="right-panel">
                <SearchBox />
                <Hits hitComponent={Hit} />
                <Pagination />
              </div>
            </InstantSearch>
          </div>
        </Layout>
      );
    }
  }

function Hit(props) {
  return (
    <div className="item-wrap">
      <a href={`/${props.hit.path}`}>
        <img src={props.hit.image} align="left" alt={props.hit.name} />
      </a>
      <div className="hit-category">
        <div className="bubble-text">{props.hit.category}</div>
      </div>
      <a href={`/${props.hit.path}`}>
        <div className="hit-title">{props.hit.title}</div>
      </a>
      <div className="hit-price">
        ${props.hit.price}
      </div>
      <div className="hit-stock">
        Stock: {props.hit.stock}
      </div>
    </div>
  );
}

Hit.propTypes = {
  hit: PropTypes.object.isRequired,
};

export default Search